<style scoped>
.margin-l-r {
  margin: 0 5px;
}

.divwrap {
  height: 200px;
  overflow-y: auto;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.divwrap >>> .distpicker-address-wrapper {
  color: #999;
}

.divwrap >>> .address-header {
  position: fixed;
  bottom: 400px;
  width: 100%;
  background: #000;
  color: #fff;
}

.divwrap >>> .address-header ul li {
  flex-grow: 1;
  text-align: center;
}

.divwrap >>> .address-header .active {
  color: #fff;
  border-bottom: #666 solid 8px
}

.divwrap >>> .address-container .active {
  color: #000;
}


.edit-offline-container {
  /*padding: 15px 0 5px 0;*/
  border-top: 1px solid #dddee1;
  margin-bottom: 20px;
}

.edit-offline-title {
  margin: 10px 0 5px 0;
  font-size: 14px;
}

.front_container {
  position: center;
}

.linestyle {
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgb(1, 5, 19);;
}

.card-title {
  width: 250px;
  height: 29px;
  font-size: 20px;
  font-family: SourceHanSansSC-Bold, SourceHanSansSC;
  font-weight: bold;
  color: rgba(75, 84, 104, 1);
  line-height: 29px;
}

.line_sprit {
  margin-right: 50px;
  cursor: pointer;
}

.line_sprit:hover {
  color: #2b62e4;
  padding-bottom: 5px;
  border-bottom: 1px solid;
}

.line_bottom_flag {
  color: #2b62e4;
  padding-bottom: 5px;
  border-bottom: 1px solid;
}

.span_text {
  width: 18px;
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
}

.card-content-stock-deduct-detail {
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddee1;
  border-bottom: 1px;
  border-left: 0px;
  border-right: 0px;
  text-align: left;
}

.readOnlyclass {
  background-color: rgba(77, 45, 45, 0.85);
}

.jiebang {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(77, 9, 9, 0.85);
}

.card {
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddee1;
  text-align: left;
}

.card-content {
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 0px;
  border: 1px solid #dddee1;
  border-bottom: 0px;
  text-align: left;
}

.card-title1 {
  width: 32px;
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}

.distpicker-address-wrapper {
  padding: 0px 10 !important;
  height: 30px !important;
  font-size: 15px !important;
  line-height: 30px !important;
}
</style>

<template>
  <div class="front_container">
    <div>
      <div>
        <Button
          icon="md-add"
          type="primary"
          style="margin-left: 26px"
          @click.prevent="apply_offline_order(new_offline_order)"
        >
          新增发货信息
        </Button>
        <!--v-if="inGroup('GROUP_MALL')" 去掉权限-->
        &nbsp;&nbsp;
        <Button
          type="primary"
          icon="md-add"
          @click.prevent="upload_view()"
        >
          申请导入发货文件
        </Button>
      </div>
      <div
        class="card-title"
        style="margin:0 auto"
      >
        发货单列表
      </div>
    </div>

    <div
      class="line text-left"
      style="margin-top:15px;margin-bottom:15px"
    >
      <Row style="margin-top:15px;margin-left:15px;">
        <i-col span="5">
          <span class="span_text">搜索类型</span>
          <Select
            v-model="params.search_info_type"
            placeholder="请选择"
            style="width:130px;margin-right:5px;margin-left:5px;"
          >
            <Option value="01">
              订单号
            </Option>
            <Option value="02">
              物流编号
            </Option>
            <Option value="03">
              收货人
            </Option>
            <Option value="04">
              收货手机号
            </Option>
            <Option value="05">
              申请人名称
            </Option>
            <Option value="06">
              项目组名称
            </Option>
            <Option value="07">
              文件批次号
            </Option>
          </Select>
        </i-col>
        <i-col span="5">
          <span class="span_text">搜索内容</span>
          <i-input
            v-if="this.params.search_info_type != '06'"
            v-model="params.search"
            placeholder="请输入搜索内容"
            style="width: 120px;margin-right:5px;margin-left:5px;"
          />
          <Select
            v-if="this.params.search_info_type == '06'"
            v-model="params.search"
            placeholder="请选择"
            style="width:120px;margin-right:5px;margin-left:5px;"
          >
            <Option
              v-for="team in order_teams"
              :key="team.value"
              :value="team.value"
            >
              {{ team.label }}
            </Option>
          </Select>
        </i-col>
        <i-col span="5">
          <span class="span_text">店铺</span>
          <Select
            v-model="params.shop"
            placeholder="请选择"
            style="width:100px;margin-right:15px;margin-left:15px;"
          >
            <Option
              v-for="shop in shops"
              :key="shop.value"
              :value="shop.value"
            >
              {{ shop.label }}
            </Option>
          </Select>
        </i-col>
        <i-col span="5">
          <span class="span_text">订单状态</span>
          <Select
            v-model="params.status"
            placeholder="请选择"
            style="width:100px;margin-right:15px;margin-left:15px;"
          >
            <Option
              v-for="status in stats"
              :key="status.value"
              :value="status.value"
            >
              {{ status.label }}
            </Option>
          </Select>
        </i-col>
      </Row>
      <Row style="margin-top:15px;margin-left:15px;">
        <i-col span="5">
          <span class="span_text">时间区间</span>
          <DatePicker
            v-model="range_time"
            type="datetimerange"
            split-panels="true"
            placeholder="请选择起止时间"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:130px;margin-right5px;margin-left:5px;"
          />
          <!--<DatePicker type="datetime" placeholder="Select date" format="yyyy-MM-dd HH:mm:ss" v-model="params.start_time"  style="width: 180px"></DatePicker>-->
        </i-col>
        <!--<i-col span="5">
          <span class="span_text">结束时间</span>
          <DatePicker type="datetime" placeholder="Select date" format="yyyy-MM-dd HH:mm" v-model="params.end_time"  style="width: 180px"></DatePicker>
        </i-col>-->
        <i-col span="10">
          <v-distpicker
            :province="this.params.province"
            :city="this.params.city"
            :area="this.params.area"
            @province="onChangeProvince"
            @city="onChangeCity"
            @area="onChangeArea"
            @selected="selected_area_query"
            :province-source="provinceSource"
            :city-source="citySource"
            :area-source="areaSource"
          />
        </i-col>
        <i-col span="8">
          <Ajaxbtn
            v-show="true"
            ref="searchBtn"
            :url="offline_order_es_query_mine"
            :params="params"
            type="search"
            @before="beforeFlowDataSearch"
            @done="handleData"
            @fail="handleFail"
          />
          <button
            class="ivu-btn ivu-btn-primary"
            style="margin-left:12px"
            @click="cancleContent()"
          >
            取消
          </button>
          <Poptip
            confirm
            title="按当前筛选条件导出?"
            @on-ok="exportOfflineOrder"
          >
            <Button
              class="margin-l-r"
              type="warning"
            >
              导出
            </Button>
          </Poptip>
          <Button
            class="ivu-btn ivu-btn-primary"
            style="margin-left:12px"
            :disabled="select_topics.length < 2"
            @click.prevent="batch_approval()"
          >
            批量审核
          </Button>
        </i-col>
      </Row>
    </div>

    <div
      class="line text-left"
      style="margin-top:15px;margin-bottom:15px"
    >
      <Row style="margin-top:15px;margin-left:15px;" />
      <span class="span_text">类型选择</span>
      <Select
        v-model="flow_data_info.type"
        placeholder="请选择"
        style="width:150px;margin-right:15px;margin-left:15px;"
        @on-change="doChangeSearch"
      >
        <Option value="01">
          发货单列表
        </Option>
        <!--v-if="inGroup('GROUP_MALL')" 去掉权限-->
        <Option
          value="02"
        >
          发货文件列表
        </Option>
      </Select>
      <RadioGroup
        v-if="this.flow_data_info.type =='01'"
        v-model="params.search_type"
        class="margin-l-r"
        type="button"
        @on-change="doSearch"
      >
        <Radio label="pending">
          待我处理发货单
        </Radio>
        <Radio label="related">
          与我相关发货单
        </Radio>
        <Radio label="mine">
          我发起的发货单
        </Radio>

        <Radio label="all">
          <Icon type="logo-buffer" />
          所有发货单
        </Radio>
      </RadioGroup>

      <RadioGroup
        v-if="this.flow_data_info.type == '02'"
        v-model="params.search_type"
        class="margin-l-r"
        type="button"
        @on-change="doSearch"
      >
        <Radio label="pending_batch">
          待我处理发货文件
        </Radio>
        <Radio label="related_batch">
          与我相关发货文件
        </Radio>
        <Radio label="mine_batch">
          我发起的发货文件
        </Radio>

        <Radio label="all">
          <Icon type="logo-buffer" />
          所有发货单
        </Radio>
      </RadioGroup>
      <span style="color: red">导入文件发货不支持批量审核</span>


      <div class="card">
        <div class="card-item">
          <Table
            v-if="this.params.search_type=='pending' "
            :columns="offline_order_pending_column"
            :data="offline_order_data"
            size="small"
            border
            @on-selection-change="selectChange"
          />
          <Table
            v-if="this.params.search_type=='related' || this.params.search_type=='mine' || this.params.search_type=='all'"
            :columns="offline_order_column"
            :data="offline_order_data"
            size="small"
            border
          />
          <Table
            v-if="this.params.search_type=='pending_batch' || this.params.search_type=='related_batch' || this.params.search_type=='mine_batch'"
            :columns="offline_order_batch_record_column"
            :data="offline_order_batch_record_data"
            size="small"
            border
          />

          <div
            v-show="page_info.total"
            class="line paginate-fix-bottom"
          >
            <Page
              show-total
              show-elevator
              :current="page_info.current"
              :total="page_info.total"
              :page-size="page_info.page_size"
              @on-change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="batch_import_loading_cfg.modal"
      title="导入发货"
      :loading="batch_import_loading_cfg.loading"
      :mask-closable="true"
      cancel-text="取消"
      ok-text="关闭"
      @on-ok="editOkImport"
    >
      <div class="line">
        <span>上传用户：</span>
        <i-input
          v-model.trim="this.cur_customer.account"
          :disabled="true"
        />
        <span>申请人：</span>
        <CustomerSelector @on-change="setBatchApplyUserId">
          {{ batch_apply_data.batch_apply_user_name || '请选择' }}
        </CustomerSelector>
        <span>申请项目组：</span>
        <Select
          v-model.trim="batch_apply_data.batch_apply_channel_id"
          placeholder="请选择团队"
        >
          <Option
            v-for="team in order_teams"
            :key="team.id"
            :value="team.value"
          >
            {{ team.label }}
          </Option>
        </Select>
      </div>
      <Upload
        :show-upload-list="false"
        style="display:inline-block"
        :before-upload="beforeUpload"
        :on-progress="uploadFileProgress"
        :on-success="uploadFileOk"
        :on-error="uploadFileFail"
        :max_size="1024*8"
        :data="batch_apply_data"
        :action="batch_path"
      >
        <Button
          type="primary"
          icon="ios-cloud-upload"
          :loading="uploading"
        >
          上传发货信息
        </Button>
      </Upload>
      <div slot="footer" />
    </Modal>

    <Modal
      v-model="batch_approval_config.modal"
      width="1000"
      title="批量审核"
      ok-text="审核通过"
      footer-hide
      :loading="batch_approval_config.loading"
      :mask-closable="false"
      @on-ok="batch_approval_ok"
    >
      <div
        v-for="order in select_topics"
        :key="order.id"
      >
        <Row style="margin-top:15px;margin-left:15px;">
          <i-col span="5">
            <span class="span_text">发货订单号:</span>
            <span class="value">{{ order.id }}</span>
          </i-col>
          <i-col span="5">
            <span class="label">申请项目组:</span>
            <span class="value">{{ order.channel_name }}</span>
          </i-col>
          <i-col span="5">
            <span class="label">价格(元):</span>
            <!-- 内控要求隐藏价格 -->
            <span class="value">**</span>
<!--            <span class="value">{{ order.item_cost/100 }}</span>-->
          </i-col>
          <i-col span="8">
            <span
              class="label"
              style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;"
            >用途描述: </span>
            <span
              class="value"
              style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;"
              data-toggle="tooltip"
              :title="order.usage_desc"
            >{{ order.usage_desc }}</span>
          </i-col>
        </Row>
        <Row style="margin-top:15px;margin-left:15px;">
          <div
            class="stock-picker link"
            @click="showViewer(order.id)"
          >
            查看发货订单详情
          </div>
        </Row>
        <Row>
          <i-col span="2" />
          <Table
            :columns="sku_columns"
            :data="order.sku_summary"
            size="small"
            border
          />
        </Row>
        <hr style="height:1px;border:none;border-top:1px dashed #252424FF; margin-top: 30px; margin-bottom: 10px">
      </div>
      <button-group style="float: right">
        <Button
          style="margin-right: 10px"
          @click="batch_approval_cancle"
        >
          取消
        </Button>
        <Button
          type="primary"
          @click="batch_approval_ok"
        >
          审核通过
        </Button>
      </button-group>
    </Modal>

    <Modal
      v-model="edit_offline_order_config.modal"
      width="1000"
      title="申请发货"
      fullscreen
      :ok-text="edit_offline_order_config.text"
      :loading="edit_offline_order_config.loading"
      :mask-closable="false"
      @on-ok="editOk"
    >
      <div class="line">
        <Form
          ref="form"
          :model="edit_offline_order"
          :rules="edit_offline_order_rules"
          :label-width="150"
        >
          <div class="line">
            <Row>
              <i-col>
                <FormItem label="申请填写人">
                  <i-input
                    v-model.trim="edit_offline_order.fill_user_name"
                    :disabled="true"
                  />
                </FormItem>
              </i-col>
              <i-col>
                <FormItem
                  label="收件人"
                  :required="true"
                >
                  <i-input v-model.trim="edit_offline_order.recv_user" />
                </FormItem>
              </i-col>
              <i-col>
                <FormItem
                  label="收件人手机号"
                  prop="recv_contact"
                >
                  <i-input v-model.trim="edit_offline_order.recv_contact" />
                </FormItem>
              </i-col>
              <i-col>
                <FormItem
                  label="选择省份/城市/区县"
                  :required="true"
                >
                  <v-distpicker
                    :province="this.edit_offline_order.province"
                    :city="this.edit_offline_order.city"
                    :area="this.edit_offline_order.area"
                    @selected="selected_area_send"
                    :province-source="provinceSource"
                    :city-source="citySource"
                    :area-source="areaSource"
                  />
                </FormItem>
              </i-col>

              <i-col>
                <FormItem
                  label="详细地址"
                  :required="true"
                >
                  <i-input v-model.trim="edit_offline_order.recv_detail_address" />
                </FormItem>
              </i-col>

              <i-col>
                <FormItem
                  label="申请人"
                  :required="true"
                >
                  <CustomerSelector @on-change="setApplyUserId">
                    {{ edit_offline_order.apply_user_name || '请选择' }}
                  </CustomerSelector>
                </FormItem>
              </i-col>

              <i-col>
                <FormItem label="申请人留言">
                  <i-input v-model.trim="edit_offline_order.apply_user_note" />
                </FormItem>
              </i-col>

              <i-col>
                <FormItem
                  label="项目组"
                  :required="true"
                >
                  <Select
                    v-model.trim="edit_offline_order.channel_id"
                    placeholder="请选择团队"
                  >
                    <Option
                      v-for="team in order_teams"
                      :key="team.value"
                      :value="team.value"
                    >
                      {{ team.label }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>

              <i-col>
                <FormItem
                  label="用途"
                  :required="true"
                >
                  <Select
                    v-model.trim="edit_offline_order.usage"
                    placeholder="请选择用途"
                  >
                    <Option
                      v-for="usage in usages"
                      :key="usage.value"
                      :value="usage.value"
                    >
                      {{ usage.label }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col>
                <FormItem
                  label="用途描述"
                  :required="true"
                >
                  <Select
                    v-model.trim="edit_offline_order.usage_desc"
                    placeholder="请选择用途描述"
                    :disabled="edit_offline_order.usage === ''"
                  >
                    <Option
                      v-for="desc in (edit_offline_order.usage === ''? []: usage_desc[edit_offline_order.usage])"
                      :key="desc"
                      :value="desc"
                    >
                      {{ desc }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col>
                <FormItem label="快递">
                  <Select
                    v-model.trim="edit_offline_order.delivery_type"
                    placeholder="请选择"
                    :required="true"
                  >
                    <Option
                      v-for="delivery in delivery_types"
                      :key="delivery.code"
                      :value="delivery.code"
                    >
                      {{ delivery.name }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>

              <i-col>
                <FormItem label="发货店铺">
                  <Select
                    v-model.trim="edit_offline_order.shop"
                    :disabled="true"
                    placeholder=""
                  >
                    <Option
                      v-for="shop in shops"
                      :key="shop.value"
                      :value="shop.value"
                    >
                      {{ shop.label }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>

              <i-col>
                <FormItem label="卖家备注">
                  <i-input v-model.trim="edit_offline_order.seller_note" />
                </FormItem>
              </i-col>
            </Row>

            <div
              v-for="(item, index) in edit_offline_order.offline_order_items"
              :key="index"
              class="edit-offline-container"
            >
              <div class="edit-offline-title">
                <span>商品 - {{ index + 1 }} </span>
                <Poptip
                  v-if="item.id===undefined"
                  confirm
                  title="您确认删除此商品吗？"
                  @on-ok="deleteItems(edit_offline_order, item, index)"
                >
                  <Button
                    size="small"
                    icon="md-close"
                  >
                    删除
                  </Button>
                </Poptip>
              </div>
              <Row :gutter="4">
                <i-col span="4">
                  <Form-item
                    :required="true"
                    label="商品存货编码"
                  >
                    <OnlineStockSelector @on-change="setInnerName(item, ...arguments)">
                      <Button
                        size="small"
                        long
                      >
                        <span v-if="item.inner_name">{{ item.inner_name }}</span>
                        <span
                          v-else
                          class="color-grey"
                        >请选择</span>
                      </Button>
                    </OnlineStockSelector>
                  </Form-item>
                </i-col>
                <i-col span="4">
                  <Form-item
                    required="true"
                    label="商品数量"
                  >
                    <i-input
                      v-model="item.count"
                      size="small"
                      @on-blur="compareItemCount(item)"
                    />
                  </Form-item>
                </i-col>
                <i-col span="4">
                  <Form-item label="商品名称">
                    <i-input
                      v-model="item.short_name"
                      size="small"
                      :disabled="true"
                    />
                  </Form-item>
                </i-col>
                <i-col span="4">
                  <Form-item label="商品售价(单位/元)">
                    <i-input
                      v-model="item.price/100"
                      size="small"
                      :disabled="true"
                    />
                  </Form-item>
                </i-col>
                <i-col span="4">
                  <Form-item label="可用库存">
                    <i-input
                      v-model="item.available_stock_num"
                      size="small"
                      :disabled="true"
                    />
                  </Form-item>
                </i-col>
              </Row>
            </div>
            <Button
              type="dashed"
              long
              icon="md-add"
              @click="addItems"
            >
              添加商品信息
            </Button>
          </div>
        </Form>
      </div>
    </Modal>

    <Modal
      v-model="batch_flow_config.modal"
      width="1000"
      title="批次流程信息"
      :loading="batch_flow_config.loading"
      :mask-closable="false"
      :ok-text="batch_flow_config.text"
      @on-ok="confirmOk"
    >
      <div>
        <span class="card-title1">
          流程状态
        </span>
        <div>
          <UserFlow :user_flow="this.user_flow_batch.user_flow" />
        </div>
      </div>
    </Modal>
    <!--库存失败详情模态框-->
    <Modal
      v-model="stock_sync_config.modal"
      width="1000"
      title="同步失败详情"
      :loading="stock_sync_config.loading"
      :mask-closable="false"
      :ok-text="stock_sync_config.text"
      @on-ok="confirmOkSync"
    >
      <div>
        <div class="line">
          <div class="list-container">
            <div class="card-content">
              <div v-if="this.stock_deduct_detail_batch_id">
                <span class="card-title1">
                  发货单批次号:  {{ this.stock_deduct_detail_batch_id }}
                </span>
              </div>
              <!--库存校验失败-->
              <div v-if="this.stock_deduct_detail_flag == 2">
                <div class="card-content-stock-deduct-detail">
                  <Row class="line">
                    <span class="linestyle"> {{ this.stock_deduct_detail }}</span>
                  </Row>
                </div>
              </div>
              <!--库存扣减失败-->
              <div v-if="this.stock_deduct_detail_flag == 3">
                <div class="card-content-stock-deduct-detail">
                  <Row class="line">
                    <span
                      class="linestyle"
                      style="color:red"
                    > {{ this.stock_deduct_detail }}</span>
                  </Row>
                </div>
              </div>
              <!--发货单驳回，库存补偿失败-->
              <div v-if="this.stock_deduct_detail_flag == 5">
                <div class="card-content-stock-deduct-detail">
                  <Row class="line">
                    <span class="linestyle">发货单批量驳回或者单次驳回进行库存调整补偿失败！（请联系后台进行库存补偿成功后，再进行流程提交审核！）</span>
                    <span
                      class="linestyle"
                      style="color:red"
                    > {{ this.stock_deduct_detail }}</span>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script lang="ts" route="/offline/order/apply">
  import Vue from 'vue'
  import VDistpicker from 'v-distpicker'
  import Util from '../../../libs/util'
  import OnlineStockSelector from './stock_detail_online_selector'
  import CustomerSelector from '../../../views/components/customer/selector';
  import UserFlowBase from '../../../views/components/flow/user_flow_base';
  import UserFlow from '../../../views/components/flow/user_flow'
  import FlowUtil from '../../../libs/flow_util';
  import OfflineOrderDetail from './offline_order_detail';
  import OfflineOrderBatchDetail from '../order/offline_order_batch_detail.vue';
  import Richtext from "../../components/richtext.vue";
  import TransportDetail from '../order/transport_detail.vue'
  import AreaSource from '@/libs/dist_picker_source.js'

  export default {
    /* router_info_start */
    router_info: {
      path: '/offline/order/apply',
      noChkout: true
    },
    /* router_info_end */
    components: {
      Richtext,
      VDistpicker,
      OnlineStockSelector,
      CustomerSelector,
      UserFlowBase,
      OfflineOrderDetail,
      OfflineOrderBatchDetail,
      UserFlow
    },

    data() {
      let defaultSearchType = 'all';
      const s = this.$route.query.search_type;
      console.log('s', s)
      if (['pending','related','mine', 'pending_batch', 'related_batch', 'mine_batch', 'all'].includes(s)) {
        defaultSearchType = s
      }
      console.log('defaultSearchType', defaultSearchType)
      return {
        sku_columns:[
          {
            title: '存货编码',
            key: 'code',
            width: 80
          },
          {
            title: '商品简称',
            key: 'name',
            width: 200,
          },
          {
            title: '数量',
            key: 'count',
            width: 80
          },
        ],
        select_topics: [],
        range_time: '',
        batch_import_loading_cfg: {
          modal: false,
          loading: true
        },
        batch_apply_data: {
          batch_upload_user_name: '',
          batch_upload_user_id: '',
          batch_apply_user_id: '',
          batch_apply_user_name: '',
          batch_apply_channel_id: '',
        },
        batch_path: Util.api.import_batch_path,
        uploading: false,
        offline_order_es_query_mine: Util.api.offline_order_es_query_mine,
        edit_offline_order: '',
        query_flag: false,
        offline_order_pending_column: [
          {
            type: 'selection',
            width: 50,
            align: 'center'
          },
          {
            title: '发货订单号',
            align: 'center',
            width: 80,
            fixed: 'left',
            key: 'id'
          },
          {
            title: '批次号',
            align: 'center',
            width: 50,
            key: 'apply_batch_id'
          },
          {
            title: '用途',
            align: 'center',
            width: 50,
            key: 'usage',
            render: (h, params) => {
              const usage = params.row.usage;
              return h('span', Util.offlineOrderSendUsage(usage));
            }
          },
          {
            title: '订单状态',
            align: 'center',
            width: 80,
            key: 'status',
            render: (h, params) => {
              const status = params.row.status;
              if (status == -1) {
                return h('span', '已废弃');
              } else if (status == 0) {
                return h('span', '已填写');
              } else if (status == 1) {
                return h('span', '审核中');
              } else if (status == 2) {
                return h('span', '待确认');
              } else if (status == 3) {
                return h('span', '已确认');
              } else if (status == 4) {
                return h('span', '已推单');
              } else if (status == 5) {
                return h('span', '已发货');
              } else if (status == 6) {
                return h('span', '已收货');
              } else if (status == 7) {
                return h('span', '已完成');
              }
            }
          },
          {
            title: '店铺',
            align: 'center',
            width: 80,
            key: 'shop',
            render: (h, params) => {
              const shop = params.row.shop;
              return h('span', Util.offlineOrderSendShop(shop));
            }
          },
          {
            title: '项目组',
            align: 'center',
            width: 80,
            key: 'channel_name'
          },
          {
            title: '填制人',
            align: 'center',
            width: 70,
            key: 'fill_user_name'
          },
          {
            title: '申请人',
            align: 'center',
            width: 70,
            key: 'apply_user_name'
          },
          {
            title: '价格(元)',
            align: 'center',
            width: 80,
            key: 'item_cost',
            render: (h, params) => {
              const item_cost = params.row.item_cost;
              // 内控要求隐藏价格
              // return h('span', item_cost / 100);
              return h('span', '**');
            }
          },
          {
            title: '收货人',
            align: 'center',
            width: 80,
            key: 'recv_user'
          },
          {
            title: '推单状态',
            width: 70,
            align: 'center',
            render: (h, params) => {
              const renderh = [];
              const row = params.row;
              const push_flag = row.push_flag
              if (push_flag == 0) {
                return h('span', '未推单');
              } else if (push_flag == 1) {
                return h('span', '推单成功');
              } else if (push_flag == 2) {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '失败'))
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  },
                  on: {
                    click: () => {
                      alert(row.push_detail)
                    }
                  }
                }, '->详情'))
                return renderh;
              }
            }
          },
          {
            title: '库存同步情况',
            width: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const renderh = [];
              if (row.stock_deduct_flag == 0) { //未同步库存
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: 'red'
                  }
                }, '未同步库存'))
              } else if (row.stock_deduct_flag == 2 || row.stock_deduct_flag == 3 || row.stock_deduct_flag == 5) { //状态为3为库存同步时校验错误
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '失败'))
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  },
                  on: {
                    click: () => {
                      this.show_stock_deduct_detail(row.apply_batch_id, row.stock_deduct_detail, row.stock_deduct_flag);
                    }
                  }
                }, '->详情'))
              } else {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  }
                }, row.stock_deduct_detail))
              }
              return h('div', renderh)
            }
          },
          {
            title: '快递信息',
            minWidth: 120,
            key: 'id',
            render: (h, params) => {
              const row = params.row
              const trans_type = row.transport_type;
              const trans_no = row.transport_no;
              const transport_detail_id = row.transport_detail_id;
              const renderh = [];
              if (trans_type != null) {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'blue',
                                 }
                               },
                               "快递类型:" + trans_type))
              }
              if (trans_no != null) {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'blue',
                                 }
                               },
                               "快递编号:" + trans_no))
              }
              if (trans_type != null && trans_no != null) {
                if (transport_detail_id != null) {
                  renderh.push(h(TransportDetail, {
                    props: {
                      type: 'TransportDetail',
                      model_id: transport_detail_id,
                      tip: false
                    },
                    style: {
                      cursor: 'pointer',
                      color: '#6600ff',
                    },
                    'class': {
                      link: true
                    }
                  }, '更多物流->'))
                } else {
                  renderh.push(h('div', {
                                   style: {
                                     cursor: 'pointer',
                                     color: 'red',
                                   }
                                 },
                                 "暂无物流信息"))
                }
              } else {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'red',
                                 }
                               },
                               "暂无快递信息"))
              }
              return h('div', renderh)
            }
          },
          {
            title: '审核状态',
            minWidth: 120,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              const offline_order_batch_record = row.offline_order_batch_record;

              if (user_flow) {
                window.eventHub.$on(`update-user-flow-${user_flow.id}`, (data) => {
                  //刷新页面
                  setTimeout(() => {
                    this.$refs.searchBtn.doAjax();
                  }, 500);
                });
                if (row.status === -1) {
                  return h('span', {
                    props: {
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px',
                      fontSize: '12px',
                      color: 'red'
                    }
                  }, '已废弃')
                }
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  },
                  on: {
                    update: (user_flow) => {
                      row.user_flow = user_flow;
                    }
                  }
                })
              } else if (offline_order_batch_record) {
                if (row.status === -1) {
                  return h('span', {
                    props: {
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px',
                      fontSize: '12px',
                      color: 'red'
                    }
                  }, '已废弃')
                }
                return h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#2D8CF0'
                  },
                  on: {
                    click: () => {
                      this.showBatchRecordFlow(offline_order_batch_record);
                    }
                  }
                }, '点击查看批次流程')
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '发货单详情',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              const renderh = [];
              renderh.push(h(OfflineOrderDetail, {
                props: {
                  type: 'OfflineOrderDetail',
                  model_id: row.id,
                  tip: false
                },
                'class': {
                  link: true
                }
              }, '查看'))
              return h('div', renderh)
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              const row = params.row
              //如果是推单失败的，则能进行修改操作（修改信息后可重新进行推单）
              const status = row.status

              const dropDown = [
                    h('DropdownItem', {
                      props: {
                        name: 'edit',
                      }
                    }, '编辑'),
                  ]
              if (row.user_flow.current_user_flow_node.flow_node_name === '填制人填写') {
                dropDown.push(h('DropdownItem', {
                  props: {
                    name: 'close',
                  }
                }, '废弃'))
              }
              if (status === 0) {
                return h('Dropdown', {
                  props: {
                    placement: 'left',
                    trigger: 'click'
                  },
                  on: {
                    'on-click': (name) => {
                      switch (name) {
                      case 'edit':
                        this.update_offline_order(row);
                        break;
                      case 'close':
                        this.close_offline_order(row);
                        break;
                      default:
                        this.$Modal.error({title: '提示', content: '未定义操作'});
                        break;
                      }
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      size: 'small'
                    }
                  }, '操作'),
                  h('DropdownMenu', {
                    slot: 'list'
                  }, dropDown)
                ]);
              }
            }
          }
        ],
        offline_order_column: [
          {
            title: '发货订单号',
            align: 'center',
            width: 80,
            fixed: 'left',
            key: 'id'
          },
          {
            title: '批次号',
            align: 'center',
            width: 50,
            key: 'apply_batch_id'
          },
          {
            title: '用途',
            align: 'center',
            width: 50,
            key: 'usage',
            render: (h, params) => {
              const usage = params.row.usage;
              return h('span', Util.offlineOrderSendUsage(usage));
            }
          },
          {
            title: '订单状态',
            align: 'center',
            width: 80,
            key: 'status',
            render: (h, params) => {
              const status = params.row.status;
              if (status == -1) {
                return h('span', '已废弃');
              } else if (status == 0) {
                return h('span', '已填写');
              } else if (status == 1) {
                return h('span', '审核中');
              } else if (status == 2) {
                return h('span', '待确认');
              } else if (status == 3) {
                return h('span', '已确认');
              } else if (status == 4) {
                return h('span', '已推单');
              } else if (status == 5) {
                return h('span', '已发货');
              } else if (status == 6) {
                return h('span', '已收货');
              } else if (status == 7) {
                return h('span', '已完成');
              }
            }
          },
          {
            title: '店铺',
            align: 'center',
            width: 80,
            key: 'shop',
            render: (h, params) => {
              const shop = params.row.shop;
              return h('span', Util.offlineOrderSendShop(shop));
            }
          },
          {
            title: '项目组',
            align: 'center',
            width: 80,
            key: 'channel_name'
          },
          {
            title: '填制人',
            align: 'center',
            width: 70,
            key: 'fill_user_name'
          },
          {
            title: '申请人',
            align: 'center',
            width: 70,
            key: 'apply_user_name'
          },
          {
            title: '价格(元)',
            align: 'center',
            width: 80,
            key: 'item_cost',
            render: (h, params) => {
              const item_cost = params.row.item_cost;
              // 内控要求隐藏价格
              // return h('span', item_cost / 100);
              return h('span', '**');
            }
          },
          {
            title: '收货人',
            align: 'center',
            width: 80,
            key: 'recv_user'
          },
          {
            title: '推单状态',
            width: 70,
            align: 'center',
            render: (h, params) => {
              const renderh = [];
              const row = params.row;
              const push_flag = row.push_flag
              if (push_flag == 0) {
                return h('span', '未推单');
              } else if (push_flag == 1) {
                return h('span', '推单成功');
              } else if (push_flag == 2) {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '失败'))
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  },
                  on: {
                    click: () => {
                      alert(row.push_detail)
                    }
                  }
                }, '->详情'))
                return renderh;
              }
            }
          },
          {
            title: '库存同步情况',
            width: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const renderh = [];
              if (row.stock_deduct_flag == 0) { //未同步库存
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: 'red'
                  }
                }, '未同步库存'))
              } else if (row.stock_deduct_flag == 2 || row.stock_deduct_flag == 3 || row.stock_deduct_flag == 5) { //状态为3为库存同步时校验错误
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '失败'))
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  },
                  on: {
                    click: () => {
                      this.show_stock_deduct_detail(row.apply_batch_id, row.stock_deduct_detail, row.stock_deduct_flag);
                    }
                  }
                }, '->详情'))
              } else {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  }
                }, row.stock_deduct_detail))
              }
              return h('div', renderh)
            }
          },
          {
            title: '快递信息',
            minWidth: 120,
            key: 'id',
            render: (h, params) => {
              const row = params.row
              const trans_type = row.transport_type;
              const trans_no = row.transport_no;
              const transport_detail_id = row.transport_detail_id;
              const renderh = [];
              if (trans_type != null) {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'blue',
                                 }
                               },
                               "快递类型:" + trans_type))
              }
              if (trans_no != null) {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'blue',
                                 }
                               },
                               "快递编号:" + trans_no))
              }
              if (trans_type != null && trans_no != null) {
                if (transport_detail_id != null) {
                  renderh.push(h(TransportDetail, {
                    props: {
                      type: 'TransportDetail',
                      model_id: transport_detail_id,
                      tip: false
                    },
                    style: {
                      cursor: 'pointer',
                      color: '#6600ff',
                    },
                    'class': {
                      link: true
                    }
                  }, '更多物流->'))
                } else {
                  renderh.push(h('div', {
                                   style: {
                                     cursor: 'pointer',
                                     color: 'red',
                                   }
                                 },
                                 "暂无物流信息"))
                }
              } else {
                renderh.push(h('div', {
                                 style: {
                                   cursor: 'pointer',
                                   color: 'red',
                                 }
                               },
                               "暂无快递信息"))
              }
              return h('div', renderh)
            }
          },
          {
            title: '审核状态',
            minWidth: 120,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              const offline_order_batch_record = row.offline_order_batch_record;

              if (user_flow) {
                window.eventHub.$on(`update-user-flow-${user_flow.id}`, (data) => {
                  //刷新页面
                  setTimeout(() => {
                    this.$refs.searchBtn.doAjax();
                  }, 500);
                });
                if (row.status === -1) {
                  return h('span', {
                    props: {
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px',
                      fontSize: '12px',
                      color: 'red'
                    }
                  }, '已废弃')
                }
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  },
                  on: {
                    update: (user_flow) => {
                      row.user_flow = user_flow;
                    }
                  }
                })
              } else if (offline_order_batch_record) {
                if (row.status === -1) {
                  return h('span', {
                    props: {
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px',
                      fontSize: '12px',
                      color: 'red'
                    }
                  }, '已废弃')
                }
                return h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#2D8CF0'
                  },
                  on: {
                    click: () => {
                      this.showBatchRecordFlow(offline_order_batch_record);
                    }
                  }
                }, '点击查看批次流程')
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '发货单详情',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              const renderh = [];
              renderh.push(h(OfflineOrderDetail, {
                props: {
                  type: 'OfflineOrderDetail',
                  model_id: row.id,
                  tip: false
                },
                'class': {
                  link: true
                }
              }, '查看'))
              return h('div', renderh)
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              const row = params.row
              //如果是推单失败的，则能进行修改操作（修改信息后可重新进行推单）
              const status = row.status
              if (status === 0) {
                return h('Dropdown', {
                  props: {
                    placement: 'left',
                    trigger: 'click'
                  },
                  on: {
                    'on-click': (name) => {
                      switch (name) {
                      case 'edit':
                        this.update_offline_order(row);
                        break;
                      case 'close':
                        this.close_offline_order(row);
                        break;
                      default:
                        this.$Modal.error({title: '提示', content: '未定义操作'});
                        break;
                      }
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      size: 'small'
                    }
                  }, '操作'),
                  h('DropdownMenu', {
                    slot: 'list'
                  }, [
                    h('DropdownItem', {
                      props: {
                        name: 'edit',
                      }
                    }, '编辑'),
                    h('DropdownItem', {
                      props: {
                        name: 'close',
                      }
                    }, '废弃'),
                  ])
                ]);
              }
            }
          }
        ],
        edit_offline_order_rules: {
          fill_user_name: [
            {required: true, message: '申请填写人不能为空！'}
          ],
          recv_user: [
            {required: true, message: '收件人不能为空！'}
          ],
          recv_contact: [
            {required: true, message: '收件人联系方式不能为空！'},
            {
              validator: (rule, value, callback, source, options) => {
                const errors = [];
                if (value && !Util.mobileCheck(value)) {
                  errors.push('请填写正确的电话号码');
                }
                callback(errors);
              }
            }
          ],
          area: [
            {required: true, message: '省/市/区县不能为空！'}
          ],
          recv_detail_address: [
            {required: true, message: '收件人详细地址不能为空！'}
          ],
          apply_user_id: [
            {required: true, message: '申请人不能为空！'}
          ],
          channel_id: [
            {required: true, message: '申请项目组不能为空！'}
          ],
          usage: [
            {required: true, message: '发货用途不能为空！'}
          ],
          usage_desc: [
            {required: true, message: '发货用途描述不能为空！'}
          ],
          shop: [
            {required: true, message: '发货店铺不能为空！'}
          ],
        },
        offline_order_data: [],
        offline_order_batch_record_column: [
          {
            title: '文件批次号',
            align: 'center',
            key: 'id'
          },
          {
            title: '申请上传人',
            align: 'center',
            key: 'upload_user_name'
          },
          {
            title: '申请人',
            align: 'center',
            key: 'apply_user_name'
          },
          {
            title: '申请项目组',
            align: 'center',
            key: 'channel_name'
          },
          {
            title: '商品数量',
            align: 'center',
            key: 'all_item_count'
          },
          {
            title: '商品价值',
            align: 'center',
            key: 'all_item_price',
            render: (h, params) => {
              const all_item_price = params.row.all_item_price;
              // 内控要求隐藏价格
              // return h('span', all_item_price / 100);
              return h('span','**')
            }
          },
          {
            title: '库存同步情况',
            align: 'center',
            key: 'stock_deduct_flag',
            render: (h, params) => {
              const row = params.row
              const stock_deduct_flag = row.stock_deduct_flag;
              const renderh = [];
              if (stock_deduct_flag == 0) {
                return h('span', '未同步');
              } else if (row.stock_deduct_flag == 2 || row.stock_deduct_flag == 3 || row.stock_deduct_flag == 5) {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '失败'))
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  },
                  on: {
                    click: () => {
                      this.show_stock_deduct_detail('', row.stock_deduct_detail, row.stock_deduct_flag);
                    }
                  }
                }, '->详情'))
              } else {
                renderh.push(h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    color: '#9999cc'
                  }
                }, row.stock_deduct_detail))
              }
              return renderh
            }
          },
          {
            title: '状态',
            align: 'center',
            key: 'status',
            render: (h, params) => {
              const status = params.row.status;
              if (status == -1) {
                return h('span', '已废弃');
              } else if (status == 0) {
                return h('span', '已填写');
              } else if (status == 1) {
                return h('span', '审核中');
              } else if (status == 2) {
                return h('span', '待确认');
              } else if (status == 3) {
                return h('span', '已确认');
              } else if (status == 4) {
                return h('span', '已推单发货');
              }
            }
          },
          {
            title: '审核状态',
            minWidth: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              window.eventHub.$on(`update-user-flow-${user_flow.id}`, (data) => {
                //刷新页面
                setTimeout(() => {
                  this.$refs.searchBtn.doAjax();
                }, 500);
              });
              if (row.status === -1) {
                return h('span', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '12px',
                    color: 'red'
                  }
                }, '已废弃')
              }
              if (user_flow) {

                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  },
                  on: {
                    update: (user_flow) => {
                      row.user_flow = user_flow;
                    }
                  }
                })
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '详情',
            align: 'center',
            width: 50,
            render: (h, params) => {
              const row = params.row;
              return h(OfflineOrderBatchDetail, {
                props: {
                  type: 'OfflineOrderBatchRecordDetail',
                  model_id: row.id,
                  tip: false
                },
                'class': {
                  link: true
                }
              }, '查看');
            }
          },
          {
            title: '操作',
            width: 70,
            align: 'center',
            render: (h, params) => {
              const row = params.row
              if (row.status === 0) {
                return h('Dropdown', {
                  props: {
                    placement: 'left',
                    trigger: 'click'
                  },
                  on: {
                    'on-click': (name) => {
                      switch (name) {
                      case 'close':
                        this.close_offline_order_batch(row);
                        break;
                      default:
                        this.$Modal.error({title: '提示', content: '未定义操作'});
                        break;
                      }
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      size: 'small'
                    }
                  }, '操作'),
                  h('DropdownMenu', {
                    slot: 'list'
                  }, [
                    h('DropdownItem', {
                      props: {
                        name: 'close'
                      }
                    }, '废弃')
                  ])
                ]);
              }
            }
          }
        ],
        offline_order_batch_record_data: [],
        params: {
          per_page: 10,
          page: 1,
          search: '', //搜索内容
          search_type: defaultSearchType, //与我相关的搜索类型
          search_info_type: '', //搜索类型
          shop: '', //店铺
          status: '', //订单状态
          start_time: '', //开始时间
          end_time: '', //结束时间
          province: '', //省
          city: '', //市
          area: '', //区
          all_list_group: false //能查看所有发货单的分组(目前只有履约团队能查看)
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        flow_data_info: {
          type: defaultSearchType.endsWith('batch') ? "02" : "01"
        },
        edit_offline_order_config: {
          modal: false,
          loading: true
        },
        batch_approval_config: {
          modal: false,
          loading: true
        },
        batch_flow_config: {
          text: '',
          modal: false,
          loading: true
        },
        stock_sync_config: {
          text: '',
          modal: false,
          loading: true
        },
        stock_deduct_detail: '',
        stock_deduct_detail_batch_id: '',
        stock_deduct_detail_flag: '',
        user_flow_batch: '',
        shops: [
          {value: 21, label: '推广店铺'},
          {value: 22, label: '运营店铺'},
          {value: 23, label: '福利店铺'},
          {value: 24, label: '赠送店铺'},
          {value: 25, label: '内购店铺'},
          {value: 26, label: '自用店铺'},
          // {value: 27, label: '其他店铺'},
          // {value: 39, label: '京东自营店铺'},
          // {value: 40, label: '当当自营店铺'},
          {value: 65, label: '分销店铺'} // 曾苗：增加新用途分销 2022-02-07 16:03
        ],
        stats: [
          {value: -1, label: '已废弃'},
          {value: 0, label: '已填写'},
          {value: 1, label: '审核中'},
          {value: 2, label: '待确认'},
          {value: 3, label: '已确认'},
          {value: 4, label: '已推单'},
          {value: 5, label: '已发货'},
          {value: 6, label: '已收货'},
        ],
        usages: [
          {value: 21, label: '推广'},
          {value: 22, label: '运营'},
          {value: 23, label: '福利'},
          {value: 24, label: '赠送'},
          {value: 25, label: '内购'},
          {value: 26, label: '自用'},
          // {value: 39, label: '京东代销调拨'},
          // {value: 40, label: '当当代销调拨'},
          // {value: 27, label: '其他'}  // 曾苗: "其他店铺"先禁掉, 不可选 2021-06-25 14:33:05
          {value: 65, label: '分销'} // 曾苗：增加新用途分销
        ],
        usage_desc: {
          25: ['公司货架补货-公司内部使用'],
          21: ['抽奖-微博/微信/粉丝群/小红书/抖音/B站/快手/直播/美拍/知乎-外部使用', '活动礼物--微博/微信/粉丝群/小红书/抖音/B站/快手/直播/美拍/知乎-外部使用', '平台博主/线下渠道推广/直播样品/线下布展/线下合作样品-外部使用', '投放--微博/微信/粉丝群/小红书/抖音/B站/快手/直播/美拍/知乎KOL，KOC-外部使用', '邀请奖品/体验课礼物/获客费用/用户转发转化奖品-外部使用', '矩阵裂变/社群活动/渠道代理-外部使用'],
          23: ['实习生/老师/离职员工/正式员工 员工激励/NPS奖励-公司内部使用', '团建礼品-公司内部使用', '员工培训礼品/新人入职礼品-公司内部使用', '节日/年会礼品-公司内部使用'],
          26: ['用户访谈/回访/测试礼物-外部使用', '外部拍摄/外包老师样品-外部使用', '供应商回购/留样/打样/寄样/返厂质检-外部使用', '需从项目组处发货-外部使用', '项目组自用-拍摄/检测/培训/备份/替换/样品/备课/课程研发/教具更新/教具替换--公司内部使用', '内部测试-公司内部使用', '内部培训-内部使用'],
          24: ['慈善推广/公益性捐赠--外部使用', '外部合作者(策划/高校老师/政府/税局/出版社/校企合作/版权方)赠品-外部使用', '高管赠礼-外部使用'],
          22: ['发货至批量采购方/供应商看样-外部使用', '小商店售卖/引流品售卖/分销-外部使用', '用户开课/体验课/打卡/活动/会员/低转高/邀请/续报/购课/买赠/兑换奖品-外部使用', '补发产品（丢件，产品缺陷，破损）/客诉安抚用户-外部使用', '政府书籍检查-外部使用'],
          65: ['分销']
        },
        delivery_types: [{'code': 1, 'name': '普通快递'}, {'code': 2, 'name': '顺丰陆运'}, {'code': 3, 'name': '顺丰空运'}, {
          'code': 4,
          'name': '在库自提'
        }],
        order_teams: [],
        provinceSource: AreaSource.province_list,
        citySource: AreaSource.city_list,
        areaSource: AreaSource.area_list,
      }
    },
    computed: {
      new_offline_order() {
        return {
          usage: '', //发货单用途
          usage_desc: '', //发货单用途描述--必填
          delivery_type: 1,
          status: '', //发货单状态
          create_at: '', //发货单创建时间
          shop: '', //发货店铺
          channel_id: '', //申请项目组
          fill_user_id: '', //申请填写人
          fill_user_name: '', //申请填写人名字
          apply_user_id: '', //申请发起人
          apply_user_name: '', //申请发起人名字
          apply_user_note: '', //申请人留言
          item_count: '', //发货单商品总数量
          item_cost: '', //发货单商品总成本
          sku_count: '', //发货单sku总数
          seller_note: '', //卖家备注
          recv_contact: '', //收货人联系电话
          recv_user: '', //收货人名称
          recv_detail_address: '', //收货人详细地区
          recv_user_note: '', //收货用户留言(暂时没用)
          province: '', //省
          city: '', //市
          area: '', //区/县
          offline_order_items: [Util.clone(this.new_offline_order_items)],
        }
      },
      new_offline_order_items() {
        return {
          item_id: '',
          sub_item_id: '',
          short_name: '',
          inner_name: '',
          price: '',
          count: '',
          available_stock_num: '',
          group_id: '' //当前商品所属商城后台的分组id
        }
      },
      teams() {
        return this.$store.state.root_teams;
      },
      teams_hash() {
        return this.$store.state.root_teams_hash;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      customer() {
        const base = {
          id: "",
          groups: [],
          is_director: false,
          is_outsource_director: false,
          is_team_leader: false,
          is_formal: false,
        };
        return Object.assign(base, this.$store.state.cur_customer);
      }
    },
    watch: {
      edit_offline_order: {
        handler: function() {
          this.edit_offline_order.shop = this.edit_offline_order.usage
        },
        deep: true
      }
    },
    created() {
      
      this.$nextTick(() => {
        this.getData();
      })
    },
    mounted() {
      this.loadUnifiedTeamList();
      this.doSearch();
    },
    methods: {
      showViewer(model_id) {
        window.eventHub.$emit('viewer-show', model_id, 'OfflineOrderDetail')
      },
      selectChange(topics) {
        this.select_topics = topics;
        console.log(topics)
      },
      apply_offline_order(edit_offline_order) {
        this.edit_offline_order = Util.clone(edit_offline_order);
        this.edit_offline_order_config.modal = true;
        this.edit_offline_order_config.loading = true;
        this.edit_offline_order_config.text = "确定申请"
        if (edit_offline_order.id != undefined && edit_offline_order.id != '') {
          this.edit_phone_details_config.text = "保存"
        }
        //设置申请填制人
        this.setFillUser(this.cur_customer)
      },
      upload_view() {
        this.batch_import_loading_cfg.loading = true;
        this.batch_import_loading_cfg.modal = true;
      },
      update_offline_order(offline_order) {
        this.edit_offline_order = offline_order
        this.edit_offline_order_config.modal = true;
        this.edit_offline_order_config.loading = true;
        this.edit_offline_order_config.text = "确定更新申请"
      },
      close_offline_order(offline_order) {
        Util.ajax.post(Util.api.offline_order_close, offline_order).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            //刷新页面
            setTimeout(() => {
              this.$refs.searchBtn.doAjax();
              this.edit_offline_order_config.modal = false;
            }, 500);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }

        }).catch((e) => {
          this.$Modal.error({title: '失败', content: e.message});
        }).finally(() => {
        });
      },
      close_offline_order_batch(offline_order_batch) {
        Util.ajax.post(Util.api.offline_batch_order_close, offline_order_batch).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            //刷新页面
            setTimeout(() => {
              this.$refs.searchBtn.doAjax();
              this.edit_offline_order_config.modal = false;
            }, 500);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }

        }).catch((e) => {
          this.$Modal.error({title: '失败', content: e.message});
        }).finally(() => {
        });
      },
      addItems() {
        const new_offline_order_item = Util.clone(this.new_offline_order_items)
        const obj = new_offline_order_item
        Object.keys(obj).forEach(item => {
          this.$set(obj, item, obj[item])
        })
        this.edit_offline_order.offline_order_items.push(obj);
      },
      deleteItems(edit_offline_order, offline_order_item, index) {
        if (offline_order_item.id) {
          alert(offline_order_item.id)
        } else {
          this.edit_offline_order.offline_order_items.splice(index, 1);
          this.$Message.success('删除成功!');
        }
      },
      setInnerName(item, inner_name, stock_name, cost_price, item_id_str, sub_item_id, sale_duration, available_stock_num, group_id) {
        item.inner_name = inner_name;
        item.short_name = stock_name;
        item.price = cost_price
        item.item_id = item_id_str
        item.sub_item_id = sub_item_id
        item.available_stock_num = available_stock_num
        item.group_id = group_id
      },
      compareItemCount(item) {
        if (item.inner_name) {
          if (item.count >= 0) {
            if (item.count > item.available_stock_num) {
              this.$Modal.confirm({
                title: '错误提示！',
                content: '存货编码【' + item.inner_name + '】存货商品可用库存不足！',
                onOk: () => {
                  item.count = '';
                }
              })
            }
          }
        }
      },
      setFillUser(customer) {
        this.edit_offline_order.fill_user_id = customer.id;
        this.edit_offline_order.fill_user_name = customer.account;
      },
      beforeFlowDataSearch() {
        if (this.range_time) {
          this.params.start_time = this.range_time[0]
          this.params.end_time = this.range_time[1]
        }
      },
      handleData(data) {
        this.loading = false;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
        if (data.type == 'single') {
          data.offline_orders.map((order, index) => {
            order._disabled = order.status === 0 || order.status === -1;
            order.offline_order_items.map((item, index) => {
              item.available_stock_num = "";
            });
          });
          this.offline_order_data = data.offline_orders
          if (this.offline_order_data.length === 0) {
            this.$Message.warning('没有结果');
          }
        } else if (data.type == 'batch') {
          this.offline_order_batch_record_data = data.batch_records
          if (this.offline_order_batch_record_data.length === 0) {
            this.$Message.warning('没有结果');
          }
        } else {
          alert('查询失败！')
        }
      },
      handleFail() {

      },
      getData() {
        if (!this.loading) {
          this.loading = true;
          console.log(this.params)
          Util.ajax.get(this.offline_order_es_query_mine, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      getDataByType(type) {
        if (!this.loading) {
          this.loading = true;
          this.params.search_type = type
          console.log(this.params)
          Util.ajax.get(this.offline_order_es_query_mine, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      doSearch() {
        this.select_topics = [];
        this.params.page = 1;
        this.params.all_list_group = this.inGroup('GROUP_MALL');
        this.getData();
      //this.$refs.searchBtn.doAjax();
      },
      doChangeSearch() {
        this.select_topics = [];
        if (this.params.search_type == 'pending') {
          this.getDataByType('pending_batch')
        } else if (this.params.search_type == 'pending_batch') {
          this.getDataByType('pending')
        } else if (this.params.search_type == 'related') {
          this.getDataByType('related_batch')
        } else if (this.params.search_type == 'related_batch') {
          this.getDataByType('related')
        } else if (this.params.search_type == 'mine') {
          this.getDataByType('mine_batch')
        } else if (this.params.search_type == 'mine_batch') {
          this.getDataByType('mine')
        } else {
          this.params.all_list_group = this.inGroup('GROUP_MALL');
          this.getDataByType('all')
        }
      },
      editOk() {
        // 1 收件人校验
        if (!this.edit_offline_order.recv_user) {
          this.$Message.error('收件人必填,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;

          }, 500);
          return;
        }
        // 2 收货人联系电话校验
        if (!this.edit_offline_order.recv_contact || !Util.mobileCheck(this.edit_offline_order.recv_contact)) {
          this.$Message.error('收货人联系电话必填,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 3 选择省份/城市/区县校验
        if (!this.edit_offline_order.province) {
          this.$Message.error('省份验证失败!请检查必输项是否设置完成。');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        if (this.edit_offline_order.province == '省' || this.edit_offline_order.city == '市' || this.edit_offline_order.area == '区') {
          this.$Message.error('选择省份/城市/区县验证失败!请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 4 收货人详细地区校验
        if (!this.edit_offline_order.recv_detail_address) {
          this.$Message.error('收货人详细地区必填,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 5 申请人校验
        if (!this.edit_offline_order.apply_user_id) {
          this.$Message.error('申请人必填,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 6 项目组校验
        if (!this.edit_offline_order.channel_id) {
          this.$Message.error('项目组必选择,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 7 用途校验
        if (!this.edit_offline_order.usage) {
          this.$Message.error('发货单用途必选择,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 8 用途描述校验
        if (!this.edit_offline_order.usage_desc) {
          this.$Message.error('发货单用途描述必填写,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }
        // 9 用途描述校验
        if (!this.edit_offline_order.delivery_type) {
          this.$Message.error('发货单快递类型必填写,请检查必输项!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        }

        // 10 发货商品必填项校验
        const offline_order_items = this.edit_offline_order.offline_order_items
        if (offline_order_items.length < 1) {
          this.$Message.error('申请商品信息必填!');
          this.edit_offline_order_config.loading = false;
          setTimeout(() => {
            this.edit_offline_order_config.loading = true;
          }, 500);
          return;
        } else {
          for (let i = 0; i < offline_order_items.length; i++) {
            const cur = offline_order_items[i]
            const inner_name = cur.inner_name
            const count = cur.count
            if (!inner_name) {
              this.$Message.error('商品存货编码必选择!');
              this.edit_offline_order_config.loading = false;
              setTimeout(() => {
                this.edit_offline_order_config.loading = true;
              }, 500);
              return;
            }
            if (!count || count <= 0) {
              this.$Message.error('商品数量必须是大于0的整数!');
              this.edit_offline_order_config.loading = false;
              setTimeout(() => {
                this.edit_offline_order_config.loading = true;
              }, 500);
              return;
            }
          }
        }

        Util.ajax.post(Util.api.add_apply_offline_order, this.edit_offline_order).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            //刷新页面
            setTimeout(() => {
              this.$refs.searchBtn.doAjax();
              this.edit_offline_order_config.modal = false;
            }, 500);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }

        }).catch((e) => {
          this.$Modal.error({title: '失败', content: e.message});
        }).finally(() => {
        });

      },
      editOkImport() {
        //刷新页面
        this.getData();
        this.batch_import_loading_cfg.loading = false
        this.batch_import_loading_cfg.modal = false
      },
      pageChange(new_page) {
        this.loading = false;
        this.params.page = new_page;
        this.getData();
      },
      setApplyUserId(customer) {
        this.edit_offline_order.apply_user_id = customer.id;
        this.edit_offline_order.apply_user_name = customer.account;
      },
      setBatchApplyUserId(customer) {
        this.batch_apply_data.batch_upload_user_name = this.cur_customer.account
        this.batch_apply_data.batch_upload_user_id = this.cur_customer.id
        this.batch_apply_data.batch_apply_user_id = customer.id;
        this.batch_apply_data.batch_apply_user_name = customer.account;
      },
      selected_area_query(data) {
      //this.params.province = data.province.value
      //this.params.city = data.city.value
      //this.params.area = data.area.value
      },
      onChangeProvince(province) {
        this.params.province = province.value
      },
      onChangeCity(city) {
        this.params.city = city.value
      },
      onChangeArea(area) {
        this.params.area = area.value
      },
      selected_area_send(data) {
        this.edit_offline_order.province = data.province.value
        this.edit_offline_order.city = data.city.value
        this.edit_offline_order.area = data.area.value
      },
      beforeUpload(file) {
        //上传文件之前检查是否勾选并填写了申请人和项目组
        if (!this.batch_apply_data.batch_apply_user_id) {
          this.$Modal.error({
            title: '提示',
            content: '请选择申请人！'
          });
          return false;
        }
        if (!this.batch_apply_data.batch_apply_channel_id) {
          this.$Modal.error({
            title: '提示',
            content: '请选择申请项目组！'
          });
          return false;
        }
        if (file.name.indexOf('%') > -1) {
          this.$Modal.error({
            title: '提示',
            content: '文件名不能包含百分号%'
          });
          return false;
        }
        this.$emit('start');
        return true;
      },
      uploadFileProgress(ev, file, fileList) {
        this.uploading = true;
        console.log('progress');
      },
      uploadFileOk(res, file, fileList) {
        this.uploading = false;
        if (res.code === 0) {
          this.$Message.success('上传并识别成功！')
          this.loading = false;
          this.getDataByType('mine_batch')
          this.batch_import_loading_cfg.modal = false;
        } else {
          this.$Modal.error({
            title: '上传文件库存校验失败：',
            width: 900,
            content: `<div style="white-space: pre-wrap">${res.msg}</div>`
          });
        }
      },
      uploadFileFail(error, file, fileList) {
        this.uploading = false;
        const msg = `<p>${error.message}</p>`;
        this.$Modal.error({
          title: '上传失败',
          content: msg
        });
      },
      showBatchRecordFlow(batch_record) {
        this.user_flow_batch = batch_record
        this.batch_flow_config.text = "关闭"
        this.batch_flow_config.modal = true;
        this.batch_flow_config.loading = true;
      },
      confirmOk() {
        this.batch_flow_config.modal = false;
        this.batch_flow_config.loading = false;
      },
      confirmOkSync() {
        this.stock_sync_config.modal = false;
        this.stock_sync_config.loading = false;
        this.stock_deduct_detail = ''
        this.stock_deduct_detail_batch_id = ''
      },
      show_stock_deduct_detail(batch_id, batch_detail, stock_deduct_detail_flag) {
        this.stock_sync_config.modal = true;
        this.stock_sync_config.loading = true;
        this.stock_sync_config.text = "关闭"
        this.stock_deduct_detail = batch_detail
        this.stock_deduct_detail_batch_id = batch_id
        this.stock_deduct_detail_flag = stock_deduct_detail_flag
      },
      inGroup(group) {
        const len = arguments.length;
        for (let i = 0; i < len; i++) {
          if (this.customer.groups.indexOf(arguments[i]) > -1) {
            return true;
          }
        }
        return false;
      },
      cancleContent() {
        this.params.search = ''
        this.params.search_type = 'all'
        this.params.search_info_type = ''
        this.params.shop = ''
        this.params.status = ''
        this.params.start_time = ''
        this.params.end_time = ''
        this.params.province = ''
        this.params.city = ''
        this.params.area = ''
      },
      exportOfflineOrder() {
        //导出时间处理
        if (this.range_time && this.range_time[0] && this.range_time[1]) {
          this.params.start_time = this.range_time[0].getTime()
          this.params.end_time = this.range_time[1].getTime()
        }
        window.open(Util.api.export_offline_order + '.xlsx?' + Util.urlEncode(this.params), '_blank');
      },
      loadUnifiedTeamList() {
        Util.ajax.get(Util.api.offline_order_unified_team_list).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            this.order_teams = Object.getOwnPropertyNames(data.data).map(function(id) {
              return {'value': id, 'label': data.data[id]};
            });
            Util.offlineOrderUnifiedTeamList = data.data;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '失败', content: e.message});
        }).finally(() => {
        });
      },
      batch_approval() {
        this.batch_approval_config.modal = true;
        this.batch_approval_config.loading = true;
      },
      batch_approval_cancle() {
        this.batch_approval_config.modal = false;
      },
      batch_approval_ok() {
        this.$util.ajax.post(Util.api.batch_pass_user_flow_node_user, {
          user_flow_ids: this.select_topics.map(t => t.user_flow.id)
        }).then((response) => {
          return response.data
        }).then((res) => {
          if (res.code === 1) {
            setTimeout(() => {
              this.$refs.searchBtn.doAjax();
              this.batch_approval_config.modal = false;
            }, 500);
            this.$Message.success({
              content: '请稍后查询审核结果!'
            });
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.batching = false;
          this.select_topics = [];
        });
      }
    }
  }
</script>
